export default __webpack_public_path__ + "static/media/hessahStore3.c9996576.jpg";